import React, {useState, useEffect} from 'react';
import './DevRoadmapBoard.css';
import {useAuth} from '../../helpers/AuthContext';
import HelpArticleLink from './HelpArticleLink';

export function RoadmapItem({text, description, helpArticleSlug}) {
    const [isExpanded, setIsExpanded] = useState(false);
    const hasDetails = Boolean(description || helpArticleSlug);

    return (
        <li className={`roadmap-item${isExpanded ? ' roadmap-item--expanded' : ''}`}>
            {hasDetails ? (
                <button
                    type="button"
                    className="roadmap-item__toggle"
                    aria-expanded={isExpanded}
                    aria-label={`${isExpanded ? 'Hide' : 'Show'} details for ${text}`}
                    onClick={() => setIsExpanded(expanded => !expanded)}
                >
                    <span className="roadmap-item__title">{text}</span>
                    <span className="roadmap-item__chevron" aria-hidden="true">›</span>
                </button>
            ) : (
                <p className="roadmap-item__title">{text}</p>
            )}
            {isExpanded && (
                <div className="roadmap-item__details">
                    {description && (
                        <p className="roadmap-item__description">{description}</p>
                    )}
                    {helpArticleSlug && (
                        <HelpArticleLink
                            slug={helpArticleSlug}
                            label="Read the help article"
                            variant="link"
                        />
                    )}
                </div>
            )}
        </li>
    );
}

export function RoadmapColumn({title, items, heightLimitPx = 200}) {
    let listStyle = { }
    if (heightLimitPx > 0) {
        listStyle = { maxHeight: `${heightLimitPx}px`, overflowY: 'auto' };
    }
    return (
        <div className="roadmap-column">
            <h4>{title} <small>({items.length || '0'})</small></h4>
            <ul style={listStyle}>
                {items.map((item, index) => (
                    <RoadmapItem key={item.uuid || index} {...item} />
                ))}
            </ul>
        </div>
    );
}

export default function DevRoadmapBoard() {
    const {fetch, API_URL} = useAuth();
    const [roadmap, setRoadmap] = useState([]);

    const fetchRoadmap = async () => {
        try {
            const response = await fetch(API_URL + '/v1/todos');
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setRoadmap(data);
        } catch (error) {
            console.error('Error fetching roadmap:', error);
        }
    };

    useEffect(() => {
        fetchRoadmap().then(() => {});
        return () => {
            setRoadmap([]);
        }
    }, []);

    if (!roadmap || roadmap.length === 0) {
        return null;
    }

    return (
        <div className="dev-roadmap-board">
            <RoadmapColumn
                key={'todo'}
                title={'To-Do'}
                items={roadmap.filter(item => item.status === 'todo')}
            />
            <RoadmapColumn
                key={'doing'}
                title={'Next Up'}
                items={roadmap.filter(item => item.status === 'doing')}
            />
            <RoadmapColumn
                key={'done'}
                title={'Done'}
                items={roadmap.filter(item => item.status === 'done')}
            />
        </div>
    )

}
